export default "__VITE_ASSET__BQLRbKWA__"